import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../../enums/eEventTypes';
import ControllerWinCombination from './ControllerWinCombination';
import eSymbolIndex from '../../symbols/eSymbolIndex';
import ControllerBringSymbolsToFront from './ControllerBringSymbolsToFront';

export default class ControllerFeatures {
  constructor({ reelsContainer, controllerReels, topContainer }) {
    this.reelsContainer = reelsContainer;
    this.ControllerReels = controllerReels;
    this.topContainer = topContainer;

    this._bringToFrontTriggerIds = [eSymbolIndex.ESI_COOKIE];

    this.init();
    this.addListeners();
  }

  init() {
    this.ControllerBringToFrontSymbols = new ControllerBringSymbolsToFront(this.topContainer);
    this.ControllerWinCombination = new ControllerWinCombination({
      controllerReels: this.ControllerReels,
      reelsContainer: this.reelsContainer,
      topContainer: this.topContainer
    });
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_ROLLING_STATE__START, this.onRollingStart, this);
  }

  onCycleDataSymbol(...args) {
  }

  onCycleAvailableSymbol(...args) {
  }

  showWin(data) {
    this.ControllerWinCombination.showCombination(data);
  }

  onRollingStart() {
    this.ControllerWinCombination.end();
    this.ControllerBringToFrontSymbols.bringAllBack();
  }

  showBonusGameStart(symbols) {
    this.ControllerWinCombination.showBonusGameStart(symbols);
  };

  onReelHitBar(reelIndex) {
    const symbols = this.ControllerReels.reels[reelIndex].symbols;
    for (let i = this.ControllerReels.topSimbolsCount; i <= symbols.length - 1 - this.ControllerReels.bottomSimbolsCount; i++) {
      const symbol = symbols[i];
      if (this._bringToFrontTriggerIds.includes(symbol.id)) {
        this.ControllerBringToFrontSymbols.bringToFront(symbol);
      }
    }
  }
}
